import { render, staticRenderFns } from "./nespresso.vue?vue&type=template&id=f045dcb0&scoped=true"
import script from "./nespresso.vue?vue&type=script&lang=js"
export * from "./nespresso.vue?vue&type=script&lang=js"
import style0 from "./nespresso.vue?vue&type=style&index=0&id=f045dcb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f045dcb0",
  null
  
)

export default component.exports